export default __webpack_public_path__ + "static/media/test_d.9dce086c.png";